<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">

            <div class="card tab2-card">

                <div class="card-header">
                    <h5>Administrador Servicios Externos</h5>
                </div>

                <div class="card-body">

                    <div class="row align-items-center mb-3">

                        <div class="col-sm-6"></div>

                        <div class="col-sm-6 text-end">

                            <button
                                class="btn btn-primary btn-create"
                                (click)="openModalContent(modalAgregarServicio, false)">

                                <i class="fa-solid fa-plus"></i>
                                Crear

                            </button>

                        </div>

                    </div>

                    <app-paginacion
                        [currentPage]="currentPage"
                        [totalItems]="totalItems"
                        [selectedPageSize]="pageSize"
                        [paginatedData]="currentItems"
                        [headers]="tableHeaders"
                        [actions]="customActions"
                        (pageChange)="onPageChange($event)"
                        (pageSizeChange)="onPageSizeChange($event)"
                        [loading]="spinner">
                    </app-paginacion>

                </div>

            </div>

        </div>
    </div>
</div>


<!-- ===================================================== -->
<!-- MODAL SERVICIO EXTERNO -->
<!-- ===================================================== -->

<ng-template #modalAgregarServicio let-modal>

    <div class="service-modal">

        <!-- ================================================= -->
        <!-- HEADER -->
        <!-- ================================================= -->

        <div class="modal-header service-modal-header">

            <div class="modal-heading">

                <div class="modal-heading-icon">
                    <i class="fa-solid fa-plug"></i>
                </div>

                <div class="modal-heading-content">

                    <h4 class="modal-title">
                        {{ isEditMode ? 'Editar servicio externo' : 'Nuevo servicio externo' }}
                    </h4>

                    <p class="modal-description">
                        Configura la información, conexión y credenciales del servicio.
                    </p>

                </div>

            </div>

            <button
                type="button"
                class="btn-close"
                aria-label="Cerrar"
                (click)="modal.dismiss('Cross click')">
            </button>

        </div>


        <!-- ================================================= -->
        <!-- BODY -->
        <!-- ================================================= -->

        <div class="modal-body service-modal-body">

            <form [formGroup]="formServicios">

                <!-- ========================================= -->
                <!-- INFORMACIÓN DEL SISTEMA -->
                <!-- ========================================= -->

                <section class="form-section">

                    <div class="section-header">

                        <div class="section-icon">
                            <i class="fa-solid fa-server"></i>
                        </div>

                        <div>

                            <h5 class="section-title">
                                Información del sistema
                            </h5>

                            <p class="section-description">
                                Identificación principal del servicio externo.
                            </p>

                        </div>

                    </div>


                    <div class="row g-3">

                        <!-- NOMBRE -->

                        <div class="col-12 col-md-6">

                            <div class="form-group">

                                <label class="form-label">
                                    Nombre del sistema
                                    <span class="required">*</span>
                                </label>

                                <div class="input-icon">

                                    <i class="fa-solid fa-desktop"></i>

                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Ej. Sistema Jobsite"
                                        formControlName="nombre" />

                                </div>

                                <span
                                    class="field-error"
                                    *ngIf="
                                        formServicios.get('nombre')?.touched &&
                                        formServicios.get('nombre')?.errors?.['required']
                                    ">

                                    <i class="fa-solid fa-circle-exclamation"></i>
                                    El nombre del sistema es requerido.

                                </span>

                            </div>

                        </div>


                        <!-- NOMBRE CORTO -->

                        <div class="col-12 col-md-6">

                            <div class="form-group">

                                <label class="form-label">
                                    Nombre corto
                                    <span class="required">*</span>
                                </label>

                                <div class="input-icon">

                                    <i class="fa-solid fa-tag"></i>

                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Ej. JOBSITE"
                                        formControlName="nombre_corto"
                                        [readOnly]="isEditMode" />

                                </div>

                                <span
                                    class="field-error"
                                    *ngIf="
                                        formServicios.get('nombre_corto')?.touched &&
                                        formServicios.get('nombre_corto')?.errors?.['required']
                                    ">

                                    <i class="fa-solid fa-circle-exclamation"></i>
                                    El nombre corto es requerido.

                                </span>

                            </div>

                        </div>

                    </div>

                </section>


                <!-- ========================================= -->
                <!-- CONEXIÓN -->
                <!-- ========================================= -->

                <section class="form-section">

                    <div class="section-header">

                        <div class="section-icon">
                            <i class="fa-solid fa-link"></i>
                        </div>

                        <div>

                            <h5 class="section-title">
                                Configuración de conexión
                            </h5>

                            <p class="section-description">
                                Direcciones utilizadas para comunicarse con el sistema.
                            </p>

                        </div>

                    </div>


                    <div class="row g-3">

                        <!-- URL BACKEND -->

                        <div class="col-12">

                            <div class="form-group">

                                <label class="form-label">
                                    URL backend
                                    <span class="required">*</span>
                                </label>

                                <div class="input-icon">

                                    <i class="fa-solid fa-link"></i>

                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Ej. https://ejemplo-backend/api/authenticate"
                                        formControlName="auth_url" />

                                </div>

                                <span
                                    class="field-error"
                                    *ngIf="
                                        formServicios.get('auth_url')?.touched &&
                                        formServicios.get('auth_url')?.errors?.['required']
                                    ">

                                    <i class="fa-solid fa-circle-exclamation"></i>
                                    La URL del backend es requerida.

                                </span>

                            </div>

                        </div>


                        <!-- BASE URL -->

                        <div class="col-12">

                            <div class="form-group">

                                <label class="form-label">
                                    Base URL
                                    <span class="required">*</span>
                                </label>

                                <div class="input-icon">

                                    <i class="fa-solid fa-globe"></i>

                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Ej. https://ejemplo-backend-dev.bcr.gob.sv/api"
                                        formControlName="base_url" />

                                </div>

                                <span
                                    class="field-error"
                                    *ngIf="
                                        formServicios.get('base_url')?.touched &&
                                        formServicios.get('base_url')?.errors?.['required']
                                    ">

                                    <i class="fa-solid fa-circle-exclamation"></i>
                                    La URL base es requerida.

                                </span>

                            </div>

                        </div>

                    </div>

                </section>


                <!-- ========================================= -->
                <!-- CREDENCIALES -->
                <!-- ========================================= -->

                <section class="form-section">

                    <div class="section-header">

                        <div class="section-icon">
                            <i class="fa-solid fa-key"></i>
                        </div>

                        <div>

                            <h5 class="section-title">
                                Credenciales
                            </h5>

                            <p class="section-description">
                                Credenciales utilizadas para autenticarse.
                            </p>

                        </div>

                    </div>


                    <div class="row g-3">

                        <!-- USERNAME -->

                        <div class="col-12 col-md-6">

                            <div class="form-group">

                                <label class="form-label">
                                    Username
                                    <span class="required">*</span>
                                </label>

                                <div class="input-icon">

                                    <i class="fa-solid fa-user"></i>

                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Ej. username"
                                        formControlName="auth_username" />

                                </div>

                                <span
                                    class="field-error"
                                    *ngIf="
                                        formServicios.get('auth_username')?.touched &&
                                        formServicios.get('auth_username')?.errors?.['required']
                                    ">

                                    <i class="fa-solid fa-circle-exclamation"></i>
                                    El usuario es requerido.

                                </span>

                            </div>

                        </div>


                        <!-- PASSWORD -->

                        <div class="col-12 col-md-6">

                            <div class="form-group">

                                <label class="form-label">
                                    Password
                                    <span class="required">*</span>
                                </label>

                                <div class="input-icon">

                                    <i class="fa-solid fa-lock"></i>

                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="**********"
                                        formControlName="auth_password"
                                        [readOnly]="firmaGuardada" />

                                </div>

                                <span
                                    class="field-error"
                                    *ngIf="
                                        formServicios.get('auth_password')?.touched &&
                                        formServicios.get('auth_password')?.errors?.['required']
                                    ">

                                    <i class="fa-solid fa-circle-exclamation"></i>
                                    El password es requerido.

                                </span>

                            </div>

                        </div>

                    </div>


                    <!-- ===================================== -->
                    <!-- AUTOCOMPLETAR -->
                    <!-- ===================================== -->

                    <div
                        class="credentials-option mt-3"
                        *ngIf="ocultarFirmaGuardada">

                        <div class="credentials-option-info">

                            <div class="credentials-option-icon">
                                <i class="fa-solid fa-wand-magic-sparkles"></i>
                            </div>

                            <div>

                                <span class="credentials-option-title">
                                    Autocompletar credenciales
                                </span>

                                <small>
                                    Utiliza las credenciales almacenadas previamente.
                                </small>

                            </div>

                        </div>


                        <label class="modern-switch mb-0">

                            <input
                                type="checkbox"
                                [(ngModel)]="firmaGuardada"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="onChangeFirmaGuardada()">

                            <span class="slider"></span>

                        </label>

                    </div>

                </section>

            </form>

        </div>


        <!-- ================================================= -->
        <!-- FOOTER -->
        <!-- ================================================= -->

        <div class="modal-footer service-modal-footer">

            <button
                type="button"
                class="btn btn-cancel"
                (click)="modal.close('Cerrar click')">

                Cerrar

            </button>


            <button
                type="button"
                class="btn btn-save"
                (click)="guardarServicio()"
                [disabled]="formServiciosIsSubmited || formServicios.invalid">

                <i
                    class="fa-solid"
                    [ngClass]="isEditMode ? 'fa-floppy-disk' : 'fa-plus'">
                </i>

                {{ isEditMode ? 'Actualizar' : 'Crear' }}

            </button>

        </div>

    </div>

</ng-template>